import React, { FC } from 'react';
import { Icon, Image, Text, Types } from '@marriott/mi-ui-library';

import { formatDateRange } from '../../modules/utils/helper';

export type ReservationCardProps = {
  propertyImageSrc?: string;
  propertyImageAltText?: string;
  propertyName?: string;
  checkInDate?: string;
  checkOutDate?: string;
  confirmationNumber?: string;
  confirmationNumberLabel?: string;
  footerIconClass?: string;
  locale: string;
  testId?: string;
};

export const ReservationCard: FC<ReservationCardProps> = ({
  propertyImageSrc,
  propertyImageAltText = '',
  propertyName,
  checkInDate,
  checkOutDate,
  confirmationNumber,
  confirmationNumberLabel,
  footerIconClass,
  locale,
  testId = 'reservation-card',
}) => {
  const stayDates =
    checkInDate && checkOutDate ? formatDateRange(checkInDate, checkOutDate, locale)?.toUpperCase() : undefined;

  return (
    <div className="wallet-award-modal__reservation-card" data-testid={testId}>
      <div className="wallet-award-modal__reservation-main">
        <div className="wallet-award-modal__reservation-image" aria-hidden="true">
          {propertyImageSrc ? (
            <Image
              src={propertyImageSrc}
              alt={propertyImageAltText}
              customClass="wallet-award-modal__reservation-image-el"
            />
          ) : (
            <div className="wallet-award-modal__reservation-image-placeholder" aria-hidden="true" />
          )}
        </div>

        <div className="wallet-award-modal__reservation-details">
          {stayDates ? (
            <Text
              element={Types.tags.div}
              fontSize={Types.size.extraSmall}
              copyText={stayDates}
              customClass="wallet-award-modal__reservation-dates t-font-xs t-font-weight-medium"
            />
          ) : null}
          {propertyName ? (
            <Text
              element={Types.tags.div}
              fontSize={Types.size.small}
              copyText={propertyName}
              customClass="wallet-award-modal__reservation-name t-subtitle-s"
            />
          ) : null}
          {confirmationNumber ? (
            <Text
              element={Types.tags.div}
              fontSize={Types.size.extraSmall}
              copyText={
                confirmationNumberLabel ? `${confirmationNumberLabel}: ${confirmationNumber}` : confirmationNumber
              }
              customClass="wallet-award-modal__reservation-confirmation t-font-xs"
            />
          ) : null}
        </div>
      </div>

      <div className="wallet-award-modal__reservation-footer" aria-hidden="true">
        {footerIconClass ? <Icon iconClass={footerIconClass} isDecorative ariaLabel="" /> : null}
      </div>
    </div>
  );
};
